import AuthManager from "Common/AuthManager";
import Utils from "Common/Utils";
import { TABSConstraints, TAttributeConstriants, TCategory, TCFConstraints } from "Components/GMS/Attribute/types";
import ServiceWrapper from "Services/ServiceWrapper";
import AppSettings from "Settings/AppSettings";
import { TAttributeValue } from "types/Pages/ProductDelta";

const api_base_url = AppSettings.GMS_BACKEND_API_URL;

export async function loadAttributes(category_ids: string[], page: number, limit: number, search_key:string='') {
  let res = await ServiceWrapper.doPost(
    api_base_url + `/get_attributes?page=${page}&limit=${limit}&search=${search_key}`,
    { category_ids: category_ids },
    null,
    AuthManager.getGmsToken()
  );

  return [res.errorfound ?? true, res?.data ?? null]
}

export async function loadAttributeValues(attributeIds: string[], page: number=1,limit:number, searchQuery: string = '') {
  let res = await ServiceWrapper.doPost(
    api_base_url + `/get_attribute_values?page=${page}&limit=${limit}&search=${searchQuery}`,
    { attribute_ids: attributeIds },
    null,
    AuthManager.getGmsToken()
  );

  return [res.errorfound ?? true, res?.data ?? null]
}


export const getAssociatedCategoriesByAttributeID = async (attributeId: string): Promise<TCategory[]> => {
  const res = await ServiceWrapper.doGet(
    AppSettings.GMS_BACKEND_API_URL + `attribute/associated_categories/${attributeId}`,
    null,
    null,
    AuthManager.getGmsToken()
  );
  
  if (res.errorfound || !res.data.data) {
    throw new Error(res.message ?? "Could not fetch associated categories");
  }
  
  return res.data.data;
};


export const getAbsConstraintsByAttributeID = async (attributeId: string,limit: number = 10,skip: number = 0,search: string | undefined = undefined,endPoint?: string): Promise<{ count: number; constraints: TABSConstraints }> => {
  const params = Utils.generateFiltersFromObject({ limit, skip, search });

  const res = await ServiceWrapper.doGet(
    AppSettings.GMS_BACKEND_API_URL + `attribute/${attributeId}/abs_constraints/get${params ? `?${params}` : ""}`,
    null,
    null,
    AuthManager.getGmsToken()
  );

  if (res.errorfound || !res.data.data) {
    throw new Error(res.message ?? "Could not fetch Abs Constraints");
  }

  return {
    count: res.data.values_count,
    constraints: res.data.data
  };
};

export const getCFConstraintsByAttributeID = async ( attributeId: string, limit: number = 10, skip: number = 0, search: string | undefined = undefined): Promise<{ count: number; constraints: TCFConstraints }> => {
  const params = Utils.generateFiltersFromObject({ limit, skip, search });

  const res = await ServiceWrapper.doGet(
    AppSettings.GMS_BACKEND_API_URL + `attribute/${attributeId}/cf_constraints/get${params ? `?${params}` : ""}`,
    null,
    null,
    AuthManager.getGmsToken()
  );

  if (res.errorfound || !res.data.data) {
    throw new Error(res.message ?? "Could not fetch Abs Constraints");
  }

  return {
    count: res.data.values_count,
    constraints: res.data.data
  };
};


export const getConstraintsByAttributeID = async ( attributeId: string): Promise<TAttributeConstriants> => {
  const res = await ServiceWrapper.doGet(
    AppSettings.GMS_BACKEND_API_URL + `attribute/${attributeId}/constraints/get`,
    null,
    null,
    AuthManager.getGmsToken()
  );

  if (res.errorfound || !res.data.data) {
    throw new Error(res.message ?? "Could not fetch Attribute constraints");
  }

  return res.data.data;
};

export const listAttributeValuesByAttributeID = async ( attributeId: string, limit: number = 10, skip: number = 0, search: string | undefined = undefined): Promise<{ count: number; attribute_values: TAttributeValue[] }> => {
  const params = Utils.generateFiltersFromObject({ limit, skip, search });

  const res = await ServiceWrapper.doGet(
    AppSettings.GMS_BACKEND_API_URL + `attribute/${attributeId}/attributevalues/list${params ? `?${params}` : ""}`,
    null,
    null,
    AuthManager.getGmsToken()
  );

  if (res.errorfound || !res.data.data) {
    throw new Error(res.message ?? "Could not fetch Attribute values");
  }

  return { 
    count: res.data.count, 
    attribute_values: res.data.data 
  };
};